import { createCallable } from "./_sdk/client";

//////// AI ////////
import type { handlers as aiHandlers } from "./ai/handlers";
const ai = createCallable<typeof aiHandlers>("ai");
////////////////////

//////// REFINER SIGNATURE ////////
import type { handlers as refinerSignatureHandlers } from "./refiner/handlers";
const refiner = createCallable<typeof refinerSignatureHandlers>("refiner");
////////////////////

//////// SEARCH ////////
import type { handlers as searchHandlers } from "./search/handlers";
const search = createCallable<typeof searchHandlers>("search");
////////////////////

//////// WORKSPACES BILLING ////////
import type { handlers as workspacesBillingHandlers } from "./workspacesBilling/handlers";
const workspacesBilling = createCallable<typeof workspacesBillingHandlers>("workspacesBilling");
////////////////////

//////// ZENDESK ////////
import type { handlers as zendeskHandlers } from "./zendesk/handlers";
const zendesk = createCallable<typeof zendeskHandlers>("zendesk");
////////////////////

//////// EMAIL ////////
import type { handlers as emailHandlers } from "./email/handlers";
const email = createCallable<typeof emailHandlers>("email");
////////////////////

//////// NOTIFICATION EVENTS ////////
import type { handlers as notificationEventsHandlers } from "./notificationEvents/handlers";
const notificationEvents = createCallable<typeof notificationEventsHandlers>("notificationevents");
////////////////////

//////// WORKSPACE RESOURCES ////////
import type { handlers as workspaceResourcesHandlers } from "./workspaceResources/handlers";
const workspaceResources = createCallable<typeof workspaceResourcesHandlers>("workspaceResources");
////////////////////

//////// WORKSPACE USERS ////////
import type { handlers as workspaceUsersHandlers } from "./workspaceUsers/handlers";
const workspaceUsers = createCallable<typeof workspaceUsersHandlers>("workspaceUsers");
////////////////////

//////// THEMES ////////
import type { handlers as themesHandlers } from "./themes/handlers";
const themes = createCallable<typeof themesHandlers>("themes");
////////////////////

//////// WORKSPACE USER GROUPS ////////
import type { handlers as workspaceUserGroupsHandlers } from "./workspaceUserGroups/handlers";
const workspaceUserGroups = createCallable<typeof workspaceUserGroupsHandlers>("workspaceUserGroups");
////////////////////

//////// WORKSPACE RESOURCE FOLDERS ////////
import type { handlers as workspaceResourceFoldersHandlers } from "./workspaceResourceFolders/handlers";
const workspaceResourceFolders = createCallable<typeof workspaceResourceFoldersHandlers>("workspaceResourceFolders");
////////////////////

//////// WORKSPACE INTEGRATIONS ////////
import type { handlers as workspaceIntegrationsHandlers } from "./workspaceIntegrations/handlers";
const workspaceIntegrations = createCallable<typeof workspaceIntegrationsHandlers>("workspaceIntegrations");
////////////////////

//////// WORKSPACE USER INVITES ////////
import type { handlers as workspaceUserInvitesHandlers } from "./workspaceUserInvites/handlers";
const workspaceUserInvites = createCallable<typeof workspaceUserInvitesHandlers>("workspaceUserInvites");
////////////////////

//////// ENTERPRISE ////////
import type { handlers as enterpriseHandlers } from "./enterprise/handlers";
const enterprise = createCallable<typeof enterpriseHandlers>("enterprise");
////////////////////

//////// COLLABORATION INVITES ////////
import type { handlers as collaborationInvitesHandlers } from "./collaborationInvites/handlers";
const collaborationInvites = createCallable<typeof collaborationInvitesHandlers>("collaborationInvites");
////////////////////

//////// DEBUG ////////
import type { handlers as debugHandlers } from "./debug/handlers";
const debug = createCallable<typeof debugHandlers>("debug");
////////////////////

//////// CLIENT LOGS ////////
import type { handlers as clientLogsHandlers } from "./clientLogs/handlers";
// useLogger = false to avoid an endless loop: logging a failed log-shipping request would
// itself get queued and re-shipped via this same callable, spamming the API.
const clientLogs = createCallable<typeof clientLogsHandlers>("clientLogs", false);
////////////////////

//////// COMMENTS ////////
import type { handlers as commentsHandlers } from "./comments/handlers";
const comments = createCallable<typeof commentsHandlers>("comments");
////////////////////

//////// WORKSPACES ////////
import type { handlers as workspacesHandlers } from "./workspaces/handlers";
const workspaces = createCallable<typeof workspacesHandlers>("workspaces");
////////////////////

//////// WORKSPACES METADATA ////////
import type { handlers as workspacesMetadataHandlers } from "./workspacesMetadata/handlers";
const workspacesMetadata = createCallable<typeof workspacesMetadataHandlers>("workspacesMetadata");
////////////////////

//////// USER EXPERIENCES ////////
import type { handlers as userExperiencesHandlers } from "./userExperiences/handlers";
const userExperiences = createCallable<typeof userExperiencesHandlers>("userExperiences");
////////////////////

export {
    ai,
    refiner,
    search,
    workspacesBilling,
    zendesk,
    workspaceResources,
    workspaceUsers,
    workspaceUserGroups,
    workspaceResourceFolders,
    workspaceIntegrations,
    workspaceUserInvites,
    enterprise,
    collaborationInvites,
    debug,
    clientLogs,
    comments,
    workspaces,
    workspacesMetadata,
    email,
    notificationEvents,
    themes,
    userExperiences
};
